import { capabilities } from "@/data/site";

function Row() {
  return (
    <div className="flex shrink-0 items-center gap-12 pr-12">
      {capabilities.map((c) => (
        <span key={c} className="flex items-center gap-12">
          <span className="whitespace-nowrap font-mono text-xs uppercase tracking-[0.3em] text-slate-500 md:text-sm">
            {c}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gradient-to-br from-blue-600 to-violet-600" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
}

export default function CapabilityMarquee() {
  return (
    <div
      data-testid="capability-marquee"
      className="group relative overflow-hidden border-y border-slate-200 bg-white py-5"
    >
      <div className="animate-marquee flex w-max group-hover:[animation-play-state:paused]">
        <Row />
        <Row />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" aria-hidden="true" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" aria-hidden="true" />
    </div>
  );
}
